import { classes } from "@/utils"

import { resolve_blog_author } from "./authors"
import type { BlogAuthorSlug } from "./types"

export interface BlogAuthorBylineProps {
  className?: string
  /** `sm` — list cards; `md` — post header */
  size?: "sm" | "md"
  /** From Sanity `post.author`; invalid/missing falls back to Nat. */
  authorSlug?: BlogAuthorSlug | string | null
}

export function BlogAuthorByline(props: BlogAuthorBylineProps) {
  const { className, size = "md", authorSlug } = props
  const profile = resolve_blog_author(authorSlug)

  const img_class =
    size === "sm" ? "h-8 w-8 shrink-0" : "h-11 w-11 shrink-0 sm:h-12 sm:w-12"
  const name_class = size === "sm" ? "text-xs font-semibold text-indigo-950" : "text-sm font-semibold text-indigo-950"
  const role_class = size === "sm" ? "text-[11px] text-indigo-600" : "text-xs text-indigo-600"

  return (
    <div class={classes("flex items-center gap-3", className ?? "")}>
      <img
        src={profile.photo_url}
        alt={profile.name}
        width={size === "sm" ? 32 : 48}
        height={size === "sm" ? 32 : 48}
        class={classes("rounded-full object-cover ring-2 ring-sky-200", img_class)}
      />
      <div class="min-w-0">
        <p class={name_class}>{profile.name}</p>
        <p class={role_class}>{profile.role}</p>
      </div>
    </div>
  )
}
